import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import {
  UserOutlined,
  FunnelPlotOutlined,
  FileTextOutlined,
  BarChartOutlined,
  AppstoreOutlined,
} from "@ant-design/icons";
import "../style.css";

const iconByIndex: Record<number, JSX.Element> = {
  0: <UserOutlined />,
  1: <FunnelPlotOutlined />,
  2: <FileTextOutlined />,
  3: <BarChartOutlined />,
};

const MINI_FUNNEL_WIDTHS = [100, 72, 52, 32];

const HighlightsSection = () => {
  const { t } = useTranslation("crm");

  const items = useMemo(() => {
    const raw = t("highlights.items", { returnObjects: true }) as unknown;
    if (!Array.isArray(raw)) return [];
    return raw as Array<{ title: string; desc: string }>;
  }, [t]);

  const funnel = useMemo(() => {
    const raw = t("highlights.funnel_mini", { returnObjects: true }) as unknown;
    if (!Array.isArray(raw)) return [];
    return raw as Array<{ key: string }>;
  }, [t]);

  const statValue = t("highlights.stat_value");
  const statLabel = t("highlights.stat_label");
  const statDesc = t("highlights.stat_desc");

  return (
    <section className="dev-crm-section dev-crm-highlights-section">
      <div className="dev-crm-section-inner">
        <h2 className="dev-section-h2 dev-crm-section-h2">
          <span className="dev-crm-section-h2-icon dev-crm-section-h2-icon--cyan" aria-hidden>
            <AppstoreOutlined />
          </span>
          <span>{t("highlights.title")}</span>
        </h2>

        <div className="dev-crm-highlights-grid">
          <div className="dev-crm-highlight-list">
            {items.map((item, idx) => (
              <div key={idx} className="dev-crm-highlight-item">
                <div className="dev-crm-highlight-icon">
                  {iconByIndex[idx] ?? <UserOutlined />}
                </div>
                <div>
                  <div className="dev-crm-highlight-title">{item.title}</div>
                  <div className="dev-crm-highlight-desc">{item.desc}</div>
                </div>
              </div>
            ))}
          </div>

          <div className="dev-crm-stat-card dev-crm-stat-card--funnel">
            <div className="dev-crm-stat-value">{statValue}</div>
            <div className="dev-crm-stat-label">{statLabel}</div>
            <div className="dev-crm-stat-desc">{statDesc}</div>
            <div className="dev-crm-stat-mini-funnel" aria-hidden>
              {funnel.map((tier, idx) => (
                <div
                  key={tier.key}
                  className={`dev-crm-stat-mini-bar dev-crm-stat-mini-bar--${tier.key}`}
                  style={{ width: `${MINI_FUNNEL_WIDTHS[idx] ?? 30}%` }}
                />
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HighlightsSection;
